// extracted by mini-css-extract-plugin
module.exports = {"menu":"dropdown-module--menu--1lTQt","item":"dropdown-module--item--3npfO"};